export type CondominiumCreditFaqItem = {
  id: string
  question: string
  answer: string
  /**
   * Trechos de `answer` que a interface destaca em negrito. Ficam fora do
   * `answer` de propósito: ele alimenta o `acceptedAnswer.text` do FAQPage no
   * JSON-LD, que precisa ser texto puro. Assim a cópia tem uma única fonte e o
   * rich snippet não carrega marcação.
   */
  highlights?: string[]
}

export const condominiumCreditFaq: CondominiumCreditFaqItem[] = [
  {
    id: 'condominium-credit-faq-0',
    question: 'O empréstimo para condomínio precisa de fiador ou avalista?',
    answer:
      'Não é necessário apresentar fiador ou oferecer bens pessoais como garantia nessa modalidade. O tomador da operação é o próprio condomínio. A contratação está sujeita à análise e às condições da operação.'
  },
  {
    id: 'condominium-credit-faq-1',
    question: 'Qual pode ser a finalidade do crédito para condomínio?',
    answer:
      'O crédito pode ser avaliado para obras, reformas, manutenção, modernização de equipamentos, projetos de eficiência energética, reparos emergenciais e outras iniciativas relacionadas ao empreendimento, conforme as condições da operação e a análise de crédito.'
  },
  {
    id: 'condominium-credit-faq-2',
    question: 'Qual é o prazo para pagar o empréstimo condominial?',
    answer:
      'Na CashMe, o Crédito para Condomínios pode ser parcelado em até 90 meses. O prazo, as taxas, a carência e as demais condições dependem da análise do condomínio e das características da operação.',
    highlights: ['90 meses']
  },
  {
    id: 'condominium-credit-faq-3',
    question: 'Existe carência para começar a pagar?',
    answer:
      'Pode haver carência de até 3 meses, conforme as condições aprovadas para a operação. Consulte a simulação para conhecer as possibilidades aplicáveis ao seu condomínio.',
    highlights: ['3 meses']
  },
  {
    id: 'condominium-credit-faq-4',
    question: 'O condomínio pode usar o crédito para uma obra emergencial?',
    answer:
      'Pode ser possível. Reparos e obras emergenciais estão entre as finalidades que podem ser avaliadas, desde que estejam de acordo com as condições da operação e sejam aprovados na análise de crédito.'
  },
  {
    id: 'condominium-credit-faq-5',
    question: 'Quanto tempo demora para liberar o crédito?',
    answer:
      'O prazo depende da conclusão das etapas de análise, aprovação e formalização. Depois da aprovação e da assinatura do contrato, a liberação ocorre conforme as condições estabelecidas para a operação.'
  },
  {
    id: 'condominium-credit-faq-6',
    question: 'Como faço uma simulação de crédito para condomínio?',
    answer:
      'Clique em Solicitar uma simulação, informe os dados do condomínio e o valor estimado para o projeto. A partir dessas informações, a CashMe poderá avaliar as possibilidades de crédito para o empreendimento.',
    highlights: ['Solicitar uma simulação']
  }
]
